import { store } from '../lib/store';

//Code that runs in app.js
export const init = () => {
	window.addEventListener('scroll', () => {
		if (window.pageYOffset > 0) {
			if(!store.getState().customState.scrolled) {
				store.dispatch({
					type: 'SCROLLED',
					scrolled: true
				})
			}
		} else {
			if (store.getState().customState.scrolled) {
				store.dispatch({
					type: 'SCROLLED',
					scrolled: false
				})
			}
		}
	});
};